import { SVC_A } from './base'

export function upload (submissions) {
  return SVC_A.post('/api/v4/cameras/upload', submissions)
}
